/**
 * Block IDs (from Sharetribe Console) that should use paragraph reveal animation.
 */
export const PARAGRAPH_REVEAL_BLOCK_IDS = [
  'hero-info-block-1',
  'paragraph',
  'more-about-lamh-block-1',
];

/**
 * Descendant selectors that should use HeroTitleReveal inside a given block.
 * Example: more-about-lamh-block-1 h4
 */
export const HERO_TITLE_REVEAL_SELECTORS_BY_BLOCK = {
  'more-about-lamh-block-1': ['h4'],
};

/**
 * Block IDs that should use scroll-triggered reveal via useCustomIdAnimate.
 */
export const CUSTOM_ID_ANIMATE_BLOCK_IDS = ['img1', 'img2', 'img3'];


/**
 * Block IDs whose parent element has ::before / ::after pseudo-elements
 * that should be animated via usePseudoElementAnimate.
 * The target DOM id is derived by stripping the block wrapper — the hook
 * looks up document.getElementById(blockId) directly.
 */


// export const PSEUDO_ANIMATE_BLOCK_IDS = ['centerimg'];

/**
 * Block IDs that should use scale 0 → 1 scroll-triggered reveal.
 */
export const SCALE_ANIMATE_BLOCK_IDS = [];
